import React from 'react';
import { FieldAnswerFeedbackWUT } from '../../../ui/field-answer-feedback/field-answer-feedback-wut';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { NumberInputWUT } from '../../../inputs/number-input-wut/number-input-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
export const QuizNumberWUT = _ref => {
  let {
    id,
    value,
    validation,
    label,
    hideLabel,
    disabled,
    readOnly,
    placeholder,
    onChange,
    onBlur,
    description,
    onFocus,
    error,
    hasError = false,
    errorMessage,
    target,
    externalData,
    required = true,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    questionImage,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement,
    questionImageAltText
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      htmlFor: inputId,
      labelId: labelId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement,
      imageAltText: questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(NumberInputWUT, {
      value: value,
      validation: validation,
      required: required,
      label: label,
      disabled: disabled,
      readOnly: readOnly,
      placeholder: placeholder,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      hasError: hasError,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedbackWUT, {
      target: target,
      externalData: externalData
    }))
  });
};
//# sourceMappingURL=quiz-number-wut.js.map